import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MeteringPoint, MenuItem } from '@model';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { SubSink } from 'subsink';
import { filter } from 'rxjs/operators';
import { SxNavigationMenuService } from '@services';
import { TranslateService } from '@ngx-translate/core';

export interface BackgroundStyle {
  background: string;
}
@Component({
    selector: 'app-multi-level-menu',
    templateUrl: './multi-level-menu.component.html',
    standalone: false
})
export class MultiLevelMenuComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  isHandset: boolean;
  @Input()
  meteringPoints: { meteringPoints: MeteringPoint[]; loaded: boolean };
  @Input()
  menuItems: MenuItem[];
  @Input()
  isWhiteLabel: boolean;


  @Output()
  toggleEvent = new EventEmitter<boolean>();

  @Output() selectedItem = new EventEmitter<MenuItem>();
  @Output() selectedLabel = new EventEmitter<MenuItem>();

  // expandCollapseStatus: MenuItemStatusEnum = null;
  // nodeExpandCollapseStatus: MenuItemStatusEnum = null;

  appRouter: Router;
  currentNode: MenuItem;
  menuItemsView: MenuItem[] = [];

  private subs = new SubSink();

  constructor(
    private router: Router,
    public navigationMenuService: SxNavigationMenuService,
    private translate: TranslateService
  ) {
    this.appRouter = router;

    this.subs.sink = router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (this.isHandset) {
          this.toggleEvent.emit(true);
        }
      });
  }

  ngOnInit() {
    // Clone the structure
    this.createLocalView();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateNodeByURL(event.urlAfterRedirects);
      }
    });

    this.updateNodeByURL(this.router.url);
    this.initMenu();
  }

  ngOnChanges() {
    // this.detectExpandCollapseStatus();
  }

  // detectExpandCollapseStatus(): void {
  //   if (this.expandCollapseStatus !== null && this.expandCollapseStatus !== undefined) {
  //     this.nodeExpandCollapseStatus = this.expandCollapseStatus;
  //   }
  // }

  createLocalView() {
    if (!this.menuItems || this.menuItems.length === 0) {
      this.menuItemsView = [];
      return;
    }

    this.cloneMenuItems(this.menuItems);
  }

  cloneMenuItems(nodes: MenuItem[]) {
    if (nodes !== null && nodes.length !== 0) {
      nodes.forEach(n => {
        let clone = this.cloneMenuItem(n);
        this.menuItemsView.push(clone);

        if (n.children && n.children.length > 0) {
          this.recursivlyCloneMenuItem(clone, n.children);
        }
      });
    }
  }

  recursivlyCloneMenuItem(node: MenuItem, children: MenuItem[]) {
    if (children !== null && children.length !== 0) {
      node.children = [];
      children.forEach(n => {
        let clone = this.cloneMenuItem(n);
        node.children.push(clone);

        if (n.children && n.children.length > 0) {
          this.recursivlyCloneMenuItem(clone, n.children);
        }
      });
    }
  }

  cloneMenuItem(node: MenuItem) {
    let clone = {
      ...node,
      checkData: node.checkData ? node.checkData : false,
      disabled: node.disabled ? node.disabled : false,
      hidden: node.hidden ? node.hidden : false
    };

    return clone;
  }

  updateNodeByURL(url: string): void {
    //console.log(`multi-level-menu\tupdateNodeByUrl\turl`, url);
    const foundNode = this.navigationMenuService.getMatchedObjectByUrl(this.menuItemsView, url);

    //console.log(`multi-level-menu\tupdateNodeByUrl\tfoundNode`, foundNode);
    if (!foundNode || !foundNode.linkUrl || foundNode.disabled) return;

    this.currentNode = foundNode;
    this.selectedListItem(foundNode);
  }

  selectedListItem(event: MenuItem): void {
    this.currentNode = event;
    if (event.children === undefined && (!event.onSelected || typeof event.onSelected !== 'function')) {
      this.selectedItem.emit(event);
    } else {
      this.selectedLabel.emit(event);
    }
    if (this.isHandset){
      this.toggleEvent.emit(true);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  initMenu(): void {
    if (this.menuItemsView.length > 0) {
      this.menuItemsView = this.menuItemsView.filter(n => !n.hidden);
      this.navigationMenuService.addContentIdToLink(this.menuItemsView);
      this.navigationMenuService.initExpanded(this.menuItemsView);
      this.navigationMenuService.tryTranslate(this.menuItemsView, this.translate);
    }
  }

  // setExpandCollapseStatus(type) {
  //   this.expandCollapseStatus = type;
  // }
}
